import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import { store } from "./app/store";
import ScrollToTop from "./components/ScrollToTop";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <HelmetProvider>
        <ScrollToTop />
        <Provider store={store}>
          <App />
        </Provider>
      </HelmetProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

// Defer vitals work to idle time so it is less likely to contend with INP.
const runVitals = () => reportWebVitals();
if (typeof window !== "undefined" && "requestIdleCallback" in window) {
  window.requestIdleCallback(runVitals);
} else {
  setTimeout(runVitals, 1);
}
